<div #group class="tab-group" [class]="width + ' ' + direction">
  <div
    class="tab-background"
    [style.transform]="
      direction === 'horizontal' ? 'translateX(' + backgroundPos + 'px)' : 'translateY(' + backgroundPos + 'px)'
    "
    [style.width.px]="direction === 'horizontal' ? backgroundSize : null"
    [style.height.px]="direction === 'vertical' ? backgroundSize : null"
  ></div>

  @for (tab of tabs; track $index) {
    <button
      #tabBtn
      type="button"
      class="tab"
      [class.active]="selectedIndex === $index"
      [ngClass]="[currentPadding, currentfontWeight]"
      [style.textAlign]="textAlign"
      (click)="selectTab($index)"
    >
      <i *ngIf="tabIcons[$index]" [class]="tabIcons[$index]"></i>
      <img *ngIf="tabImages[$index]" [src]="tabImages[$index]" [alt]="tab" />
      @if (translateTabs) {
        {{ tab | translate }}
      } @else {
        {{ tab }}
      }
    </button>
  }
</div>
